import { Typography, Button, Badge, Tooltip, LinearProgress, DialogContent, Dialog } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import '../styles/Globales.scss';
import '../styles/SolicitarPortabilidad.scss';
import React, { Component } from 'react';
import appStore from '../stores/AppStore.js';
import DetalleRotativoComponent from './utils/DetalleRotativoComponent';
import DetalleCreditoComponent from './utils/DetalleCreditoComponent';
import DetalleCuentaBancariaComponent from './utils/DetalleCuentaBancariaComponent';
import { LocalMallOutlined, KeyboardBackspaceOutlined, Close, Info } from '@material-ui/icons';
import ResumenPortabilidadComponent from './ResumenPortabilidadComponent';
import Drawer from '@material-ui/core/Drawer';
import NuevoCompromisoDeudaComponent from './utils/NuevoCompromisoDeudaComponent';
import ViewConstants from '../utils/ViewConstants';
import SeleccionFamiliaComponent from './utils/SeleccionFamiliaComponent';
import * as ProductosConstants from '../utils/ProductosConstants';

const LISTADO_PRODUCTOS = 2;
const INGRESO_PRODUCTO = 5;
const COMPROMISO_DEUDA = 6;
const TIEMPO_TOOLTIP = 2000;
export default class SolicitarNuevaPortabilidad extends Component {
  constructor(props) {
    super(props);
    this.state = {
      etapa: this.props.etapaInicial,
      openResumen: false,
      numeroProductos: appStore.solicitarNuevaPortalidadStore.bolsaProductos.length,
      openTooltipBolsa: false,
      tooltipShowed: false,
      openInfoCuentaCredito: false,
      openInfoBancaria: false,
    };
  }

  okBancos = () => {
    this.setState({
      cmbBancos: appStore.solicitarNuevaPortalidadStore.cmbBancos,
      cmbFamilasProductos: appStore.solicitarNuevaPortalidadStore.cmbFamilasProductos,
    });
  };

  onCancelarIngreso = () => {
    this.setState({ etapa: LISTADO_PRODUCTOS });
  };

  renderIngresoProducto = (tipoFamilia) => {
    let result;
    const lista = appStore.solicitarNuevaPortalidadStore.listarProductosPorNemoFamilia(tipoFamilia);
    switch (tipoFamilia) {
      case ProductosConstants.FAMILIA_CUENTAS:
        result = <DetalleCuentaBancariaComponent onCancelar={this.onCancelarIngreso} listaTiposProductos={lista} onAgregar={this.onAddProducto} />;
        break;
      case ProductosConstants.FAMILIA_ROTATIVOS:
        result = <DetalleRotativoComponent onCancelar={this.onCancelarIngreso} listaTiposProductos={lista} onAgregar={this.onAddProducto} />;
        break;
      case ProductosConstants.FAMILIA_CREDITOS:
        result = <DetalleCreditoComponent onCancelar={this.onCancelarIngreso} listaTiposProductos={lista} onAgregar={this.onAddProducto} />;
        break;
      case ProductosConstants.FAMILIA_OTROS:
        result = <DetalleCuentaBancariaComponent onCancelar={this.onCancelarIngreso} onAgregar={this.onAddProducto} />;
        break;
      default:
        break;
    }
    return result;
  };

  conCompromisoDeuda = (datosTarjetas, datosLineas) => {
    appStore.generateDataLayer({ eventAction: 'step_4', eventLabel: 'algunos_compromiso_continuar' });
    const producto = {
      codProducto: ProductosConstants.FAMILIA_ROTATIVOS,
      nombreProducto: 'Tarjetas y/o Líneas de Crédito',
      compromisoDeuda: {
        lineas: datosLineas,
        tarjetas: datosTarjetas,
      },
    };
    appStore.solicitarNuevaPortalidadStore.agregarProducto(producto);
    appStore.changeNavigation(ViewConstants.ETAPA_PRODUCTOS_A_CONTRATAR);
  };

  renderCompromisoDeuda = () => {
    return (
      <div className="bloqueSeleccionBanco">
        <NuevoCompromisoDeudaComponent
          onContinuar={this.conCompromisoDeuda}
          onVolver={() => this.setState({ etapa: LISTADO_PRODUCTOS })}
          tipoProducto={ProductosConstants.FAMILIA_ROTATIVOS}
          requerido={true}
        />
      </div>
    );
  };

  getContenido = (etapa) => {
    let result;
    if (etapa === LISTADO_PRODUCTOS) {
      result = this.listarProductos();
    } else if (etapa === INGRESO_PRODUCTO) {
      result = this.renderIngresoProducto(this.state.tipoFamiliaSeleccionada);
    } else if (etapa === COMPROMISO_DEUDA) {
      result = this.renderCompromisoDeuda();
    }
    return result;
  };

  checkTooltipBolsa = () => {
    this.setState({ openTooltipBolsa: true, tooltipShowed: true }, () => {
      setTimeout(() => {
        this.setState({ openTooltipBolsa: false });
      }, TIEMPO_TOOLTIP);
    });
  };

  onAddProducto = (producto) => {
    appStore.solicitarNuevaPortalidadStore.agregarProducto(producto);
    this.setState({ numeroProductos: appStore.solicitarNuevaPortalidadStore.bolsaProductos.length }, this.checkTooltipBolsa);
  };

  onEliminarFamilia = (tipoFamilia) => {
    appStore.solicitarNuevaPortalidadStore.eliminarFamilia(tipoFamilia);
    this.setState({ numeroProductos: appStore.solicitarNuevaPortalidadStore.bolsaProductos.length }, this.forceUpdate);
  };

  onAgregarIndividual = (tipoFamilia) => {
    this.setState({ tipoFamiliaSeleccionada: tipoFamilia, etapa: INGRESO_PRODUCTO });
  };

  onContinuar = () => {
    appStore.generateDataLayer({ eventAction: 'step_3.2', eventLabel: 'algunos_productos_continuar' });
    if (this.state.etapa === COMPROMISO_DEUDA) {
      appStore.changeNavigation(ViewConstants.ETAPA_PRODUCTOS_A_CONTRATAR);
    } else if (appStore.solicitarNuevaPortalidadStore.familiaSeleccionada(ProductosConstants.FAMILIA_ROTATIVOS)) {
      this.setState({ etapa: COMPROMISO_DEUDA, openResumen: false });
    } else {
      appStore.changeNavigation(ViewConstants.ETAPA_PRODUCTOS_A_CONTRATAR);
    }
  };

  onVolver = () => {
    if (this.state.etapa === COMPROMISO_DEUDA) {
      this.setState({ etapa: LISTADO_PRODUCTOS });
    } else if (this.state.etapa === INGRESO_PRODUCTO) {
      this.setState({ etapa: LISTADO_PRODUCTOS });
    } else if (this.state.etapa === LISTADO_PRODUCTOS) {
      appStore.changeNavigation(ViewConstants.ETAPA_SELECCION_BANCO);
    }
  };

  listarProductos = () => {
    const listado = appStore?.solicitarNuevaPortalidadStore?.cmbFamilasProductos.map((tipo, index) => {
      let etiqueta;
      let etiquetaAgregar;
      let todosSeleccionado = false;
      let result;
      if (tipo.value !== ProductosConstants.TODOS_LOS_PRODUCTOS && tipo.value !== ProductosConstants.FAMILIA_OTROS) {
        todosSeleccionado = appStore.solicitarNuevaPortalidadStore.familiaSeleccionada(tipo.value);
        switch (tipo.value) {
          case ProductosConstants.FAMILIA_CUENTAS:
            etiqueta = 'Todas mis cuentas bancarias';
            etiquetaAgregar = 'Agregar cuenta bancaria';
            break;
          case ProductosConstants.FAMILIA_ROTATIVOS:
            etiqueta = 'Todas mis tarjetas y/o líneas de crédito';
            etiquetaAgregar = 'Agregar tarjeta o linea de crédito';
            break;
          case ProductosConstants.FAMILIA_CREDITOS:
            etiqueta = 'Todos mis créditos';
            etiquetaAgregar = 'Agregar Credito';
            break;
          case ProductosConstants.FAMILIA_OTROS:
            etiqueta = 'Todos mis otros productos';
            etiquetaAgregar = 'Agregar otro producto';
            break;
          default:
            break;
        }
        result = (
          <SeleccionFamiliaComponent
            key={index}
            etiquetaSwitch={etiqueta}
            tipoFamilia={tipo}
            todosEncendido={this.onAddProducto}
            onTodosApagado={this.onEliminarFamilia}
            todosSeleccionado={todosSeleccionado}
            onAgregarIndividual={this.onAgregarIndividual}
            etiquetaAgregar={etiquetaAgregar}
          />
        );
      }
      return result;
    });
    return (
      <div className="bloqueSeleccionBanco">
        <Typography className="tituloStepSolicitud">
          Elige los productos que quieres portar desde <strong>{appStore?.solicitarNuevaPortalidadStore?.bancoSeleccionado?.nombre}</strong> a <strong>Banco Ripley</strong>.
        </Typography>
        {listado}
        <IconButton
          className="cuentaBancaria"
          onClick={() => {
            this.setState({ openInfoBancaria: true });
          }}
        >
          <Info />
        </IconButton>
        <IconButton
          className="cuentacredito"
          onClick={() => {
            this.setState({ openInfoCuentaCredito: true });
          }}
        >
          <Info />
        </IconButton>
        <div className="botones">
          <Button color="primary" id="btnVerifica" className="btnRipley" fullWidth={true} onClick={this.onContinuar} disabled={this.state.numeroProductos === 0}>
            Continuar
          </Button>
        </div>

        <Dialog open={this.state.openInfoBancaria}>
          <DialogContent>
            <div className="cerrarBtnModal">
              <IconButton
                onClick={() => {
                  this.setState({ openInfoBancaria: false });
                }}
              >
                <Close></Close>
              </IconButton>
            </div>
            <Typography className="tituloModalCarnet">Cuentas Bancarias</Typography>
            <Typography>Cuenta corriente, cuenta vista y cuenta prepago.</Typography>
          </DialogContent>
          <div>
            <div className="franjaColores">
              <div className="rojo" />
              <div className="amarillo" />
              <div className="morado" />
            </div>
          </div>
        </Dialog>

        <Dialog open={this.state.openInfoCuentaCredito}>
          <DialogContent>
            <div className="cerrarBtnModal">
              <IconButton
                onClick={() => {
                  this.setState({ openInfoCuentaCredito: false });
                }}
              >
                <Close></Close>
              </IconButton>
            </div>
            <Typography className="tituloModalCarnet">Créditos</Typography>
            <Typography>Consumo, comercial, hipotecario, automotriz y otros créditos</Typography>
          </DialogContent>
          <div>
            <div className="franjaColores">
              <div className="rojo" />
              <div className="amarillo" />
              <div className="morado" />
            </div>
          </div>
        </Dialog>
      </div>
    );
  };

  shiftResumen = () => {
    this.setState(
      (prevState) => ({
        openResumen: !prevState.openResumen,
      })
    );
  };

  eliminarProductoBolsa = (producto) => {
    const index = appStore.solicitarNuevaPortalidadStore.bolsaProductos.indexOf(producto);
    if (index >= 0) {
      appStore.solicitarNuevaPortalidadStore.bolsaProductos.splice(index, 1);
    }
    this.setState({ numeroProductos: appStore.solicitarNuevaPortalidadStore.bolsaProductos.length });
    this.forceUpdate();
  };

  render() {
    let titulo;
    if (this.state.etapa === LISTADO_PRODUCTOS) {
      titulo = 'Selecciona tus productos';
    } else if (this.state.etapa === INGRESO_PRODUCTO) {
      const familia = appStore.solicitarNuevaPortalidadStore.buscarFamiliaPorNemo(this.state.tipoFamiliaSeleccionada);
      if (familia) {
        titulo = familia.nombre;
      }
    } else if (this.state.etapa === COMPROMISO_DEUDA) {
      titulo = 'Compromiso no aumentar deuda';
    }
    return (
      <div className="contenedorPrincipal">
        <div className="paso">
          <div>
            <Typography className="tituloBR">
              <IconButton onClick={this.onVolver}>
                <KeyboardBackspaceOutlined />
              </IconButton>
              {titulo}
            </Typography>
          </div>
          <IconButton aria-label="bag" className="bolsaCompras" onClick={this.shiftResumen}>
            <Badge overlap="rectangular" badgeContent={this.state.numeroProductos} color="secondary">
              <Tooltip open={this.state.openTooltipBolsa} title="Producto agregado a tu bolsa de portabilidad" arrow placement="left-start" className="tooltipBolsa">
                <LocalMallOutlined />
              </Tooltip>
            </Badge>
          </IconButton>
        </div>
        <LinearProgress variant="determinate" color="secondary" value={appStore.navigationSection * (100 / ViewConstants.TOTAL_ETAPAS)} className="barraProgreso" />
        {this.getContenido(this.state.etapa, this.state.numeroProductos)}
        <Drawer open={this.state.openResumen} anchor="right" onClose={this.shiftResumen} className="drawer">
          <ResumenPortabilidadComponent onCerrar={this.shiftResumen} onCompletar={this.onContinuar} onDeleteItem={this.eliminarProductoBolsa} />
        </Drawer>
      </div>
    );
  }
}

SolicitarNuevaPortabilidad.defaultProps = {
  etapaInicial: LISTADO_PRODUCTOS,
};
